import styled from "styled-components"

export const Wrapper = styled.div`
  position: absolute;
  bottom: 7.5%;
  /* 
    These sizes are not as arbitrary as they look,
    as they are just small enough to keep this component
    hidden behind its quizkit overlay counterpart.
  */
  right: 10%;
  left: 10%;
  height: 12.5vw;
  font-size: 1.2vw;
`